import { forwardRef, useCallback } from 'react'
import { useRouter } from 'next/router'

//* Helpers
import { config } from 'helpers'

//* Components
import Text from 'components/common/Text'
import Image from 'components/common/Image'
import Icon from 'components/common/Icon'
import CustomLink from 'components/common/CustomLink'

//* Style
import EventItemStyle from './style'

const EventItem = forwardRef(({ className, data, onCategoryChange, index }, ref) => {
    const router = useRouter();

    const onTagClick = useCallback(
        (e, id) => {
            e.preventDefault()
            onCategoryChange && onCategoryChange('tagIds', id, true)
        },
        [onCategoryChange]
    )

    return (
        <EventItemStyle className={className || ''} ref={ref}>
            <CustomLink className='item-cont' url={data.slug}>
                <Image
                    objectFit={'cover'}
                    src={data.featured_image.url}
                    className={'event-item-image'}
                    priority={router.pathname == config.routes.events.path ? index < 12 : false}
                />
                <div className='item-content'>
                    <Text className={'h6 font-ping-bolder event-item-title'} text={data.title} />
                    <Text className={' font-helvetica event-item-description pS'} text={data.featured_description} />
                    <div className='hashtags-wrap'>
                        {data.tags.map((tag) => (
                            <Text key={tag.id} className={'hashtag pXS font-helvetica'} onClick={(e) => onTagClick(e, tag.id)} text={tag.name} />
                        ))}
                    </div>
                    <Text className={'pS font-soundscape-bold bgYellowTan event-item-date'} text={data.date} />
                    <div className={'location-wrap'}>
                        <Icon name={'pin'} className={'location-icon'} />
                        <Text className={'pXS font-ping-bold location'} text={data.location} />
                    </div>
                </div>
            </CustomLink>
        </EventItemStyle>
    )
})

export default EventItem
